import { IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Length } from 'class-validator';

export class InvoiceBillingItemCreateDto {
  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  itemName: string;

  @IsOptional()
  @IsString()
  @Length(0, 250)
  itemDescription?: string;

  @IsNotEmpty()
  @IsNumber({maxDecimalPlaces: 2})
  itemPrice: number;

  @IsNotEmpty()
  @IsInt()
  itemQuantity: number;

  @IsNotEmpty()
  @IsNumber({maxDecimalPlaces: 2})
  itemAmount: number;

  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  itemVatClass: string;

  @IsNotEmpty()
  @IsNumber({maxDecimalPlaces: 2})
  itemVatValue: number;

  @IsNotEmpty()
  @IsNumber({maxDecimalPlaces: 2})
  itemVatAmount: number;
}